// The Sidebar is a fixed element, so add any spacing/width here so we can calculate the page content's padding
export default {
    width: '14.5rem',
    paddingVertical: '1.5rem',
    paddingHorizontal: '0.5rem',
};
